import type { HandleClientError } from '@sveltejs/kit';

export const handleError = (({ error }): App.Error => {
    console.error(error);

    return {
        message: 'Error'
    };
}) satisfies HandleClientError;
